var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { useMedia } from 'react-media-match';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatCurrency } from '../../../../FormattedCurrency';
import { useInstallmentCalculatorContext } from '../../../Context';
import messages from './messages';
var StyledOverviewTable = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8125rem;\n  border-radius: 5px;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  flex-direction: column;\n  font-size: 0.8125rem;\n  border-radius: 5px;\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var cardLayout = _a.cardLayout, isMobile = _a.isMobile, theme = _a.theme;
    return !isMobile &&
        !cardLayout &&
        "border: .0625rem solid " + theme.component.installmentcalculator.borderColor + ";";
}, function (_a) {
    var isMobile = _a.isMobile, cardLayout = _a.cardLayout;
    return isMobile || cardLayout
        ? 'width: 100%; min-width: 0;'
        : 'padding: 0 .875rem; width: 45%; min-width: 250px;';
});
var ListRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 3rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.375rem 0;\n  ", "\n  &:first-of-type {\n    ", "\n  }\n  &:last-of-type {\n    border: 0px none;\n  }\n"], ["\n  display: flex;\n  gap: 3rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.375rem 0;\n  ",
    "\n  &:first-of-type {\n    ",
    "\n  }\n  &:last-of-type {\n    border: 0px none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "border-bottom: .0625rem solid " + theme.component.installmentcalculator.borderColor + ";";
}, function (_a) {
    var calculatorType = _a.calculatorType, cardLayout = _a.cardLayout, theme = _a.theme;
    return calculatorType === 'DYNAMIC' &&
        cardLayout &&
        "border-top: .0625rem solid " + theme.component.installmentcalculator.borderColor + ";";
});
var RowLabel = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var cardLayout = _a.cardLayout;
    return !cardLayout && 'margin-left: 0.5rem;';
});
var RowValue = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var parseValueToPercent = function (toParse, locale) {
    return (toParse / 100).toLocaleString(locale, {
        minimumFractionDigits: 2,
        style: 'percent',
    });
};
var minimalCalcRows = ['firstInstallment', 'singleInstallment', 'overallPrice'];
export var OverviewTable = function (_a) {
    var _b = _a.isMinimal, isMinimal = _b === void 0 ? false : _b;
    var _c = useInstallmentCalculatorContext(), response = _c.response, isCardLayout = _c.config.isCardLayout;
    if (!response) {
        return null;
    }
    var currency = response.currency, displayOrder = response.displayOrder, numberOfRegularInstallments = response.numberOfRegularInstallments, _d = response.overallPrice, overallPrice = _d === void 0 ? { value: 0 } : _d, _e = response.singleInstallment, singleInstallment = _e === void 0 ? { value: 0 } : _e, type = response.type;
    var rows = isMinimal
        ? displayOrder.filter(function (tableRow) { return minimalCalcRows.includes(tableRow); })
        : displayOrder;
    var intl = useIntl();
    var mobile = useMedia({ desktop: false, mobile: true, tablet: false });
    var formatFunctions = {
        label: function (txt) { return React.createElement(RowLabel, { cardLayout: isCardLayout }, txt); },
        value: function (txt) { return React.createElement(RowValue, null, txt); },
    };
    var tableRowsToDisplay = [];
    // eslint-disable-next-line array-callback-return, consistent-return
    rows.map(function (tableRow, index) {
        // need to use const here. The object is marked as possibly null if `response[tableRow]` is used directly
        var responseTableRow = response[tableRow];
        if (typeof responseTableRow !== 'undefined') {
            switch (tableRow) {
                case 'monthlyInterestRateFactor':
                case 'yearlyInterestRateFactor':
                case 'fixedMonthlyInterestFactor':
                    tableRowsToDisplay.push(React.createElement(ListRow, { key: tableRow.concat(index.toFixed()), calculatorType: type, cardLayout: isCardLayout }, intl.formatMessage(messages[tableRow], __assign(__assign({}, formatFunctions), { data: parseValueToPercent(responseTableRow.value, intl.locale) }))));
                    break;
                case 'singleInstallment':
                    tableRowsToDisplay.push(React.createElement(ListRow, { key: tableRow.concat(index.toFixed()), calculatorType: type, cardLayout: isCardLayout }, type === 'DYNAMIC' ? (intl.formatMessage(messages.singleInstallmentRVC, __assign(__assign({}, formatFunctions), { data: formatCurrency(currency, singleInstallment.value * 100, intl) }))) : (React.createElement(FormattedMessage, { id: "installment-calculator.single-installment-default", defaultMessage: "<label>{noOfInstallments} Folgeraten je</label><value>{data}</value>", values: __assign(__assign({}, formatFunctions), { data: formatCurrency(currency, singleInstallment.value * 100, intl), noOfInstallments: numberOfRegularInstallments }) }))));
                    break;
                case 'overallPrice':
                    tableRowsToDisplay.push(React.createElement(ListRow, { key: tableRow.concat(index.toFixed()), calculatorType: type, cardLayout: isCardLayout }, type === 'DYNAMIC' ? (intl.formatMessage(messages.overallPriceRVC, __assign(__assign({}, formatFunctions), { data: formatCurrency(currency, overallPrice.value * 100, intl) }))) : (React.createElement(React.Fragment, null,
                        React.createElement(RowLabel, { cardLayout: isCardLayout },
                            React.createElement("strong", null,
                                React.createElement(FormattedMessage, { id: "installment-calculator.overall-price-default", defaultMessage: "Dein Ratenkaufpreis" }))),
                        React.createElement(RowValue, null,
                            React.createElement("strong", null, formatCurrency(currency, overallPrice.value * 100, intl)))))));
                    break;
                default:
                    tableRowsToDisplay.push(React.createElement(ListRow, { key: tableRow.concat(index.toFixed()), calculatorType: type, cardLayout: isCardLayout }, intl.formatMessage(messages[tableRow], __assign(__assign({}, formatFunctions), { data: formatCurrency(currency, responseTableRow.value * 100, intl) }))));
            }
        }
    });
    return tableRowsToDisplay.length > 0 ? (React.createElement(StyledOverviewTable, { cardLayout: isCardLayout, isMobile: mobile }, tableRowsToDisplay)) : null;
};
export default OverviewTable;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map